module.exports = __webpack_public_path__ + "img/badge.13d3f472.png";